angular.module('admin').controller('LogsCtrl', function (
    $uibModal,
    AdminLogsResource,
    TypeaheadResource
) {

    this.currentMonth = new Date;
    this.searchParams = {};

    this.pagination = {
        page: 1,
        pageSize: 20
    };

    this.filters = {
        subscriptionNumber: null,
        customerId: null,
        supervisorId: null
    }

    this.changeMonth = function () {
        this.pagination.page = 1;
        this.loadData();
    }

    this.getCustomers = function (search) {
        var par = {
            search: search
        };
        var typeahead = TypeaheadResource.customers(par);
        return typeahead.$promise;
    }
    this.getSupervisors = function(search){
        var par = {search: search};
        return TypeaheadResource.supervisors(par).$promise;
    }

    this.onSelectCustomer = function (item, model) {
        this.searchParams.customerId = item.id;
    }
    this.onCustomersChange = function () {
        if (!this.customer)
            delete this.searchParams.customerId;
    }

    this.onSelectSupervisor = function (item, model) {
        
        this.searchParams.supervisorId = item.id;
    }
    this.onSupervisorChange = function () {
        if (!this.supervisor)
            delete this.searchParams.supervisorId;
    }

    this.submitSearch = function(){
        this.pagination.page = 1;
        this.loadData();
    }

    this.loadData = function () {

        AdminLogsResource.query(angular.extend(this.searchParams, {
            page: this.pagination.page,
            pageSize: this.pagination.pageSize,
            period: this.currentMonth
        }), (data) => {
            this.results = data;

        }, (err) => {

            //this.errorMessage = err.data.message;
        });
    }

    this.showDetails = function (log) {
        var instance = $uibModal.open({
            templateUrl: 'views/admin/logs/log_details.html',
            controllerAs: 'ctrl',
            controller: function (log, $uibModalInstance) {
                this.log = log;
                if (log.json) {
                    var json = JSON.parse(log.json);
                    var properties = [];
                    for (var p in json) {
                        properties.push({ key: p, value: json[p] });
                    }

                    this.properties = properties;
                }

                this.close = function () {
                    $uibModalInstance.dismiss();
                }
            }, resolve: {
                log: () => log
            }
        });
    }

    this.loadData();


}).config(function ($stateProvider) {
    $stateProvider.state('admin.logs', {
        url: 'logs',
        templateUrl: 'views/admin/logs/view.html',
        controllerAs: 'ctrl',
        controller: 'LogsCtrl'
    });
});